import AuthService from '@/js/services/auth.service';

const user = JSON.parse(localStorage.getItem('user'));
const private_data = JSON.parse(localStorage.getItem('private_data'));
const initialState = user?.access_token
  ? { status: { loggedIn: true }, user, private_data }
  : { status: { loggedIn: false }, user: {} };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    refreshToken({ commit }, user) {
      commit('refreshToken', user);
    },
    login({ commit }, user) {
      return AuthService.login(user).then(
        (user) => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        (error) => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },

    setPrivateData({ commit }, private_data) {
      //изменено
      commit('setPrivateData', private_data);
    },
  },

  mutations: {
    refreshToken(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = {};
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = {};
    },
    setPrivateData(state, private_data) {
      state.private_data = private_data;
    },
  },
  getters: {
    isLoggedIn(state) {
      return state.status.loggedIn;
    },
    getPrivateData(state) {
      return state?.private_data;
    },
  },
};
